import { CommonUtils } from '../utils/CommonUtils';
import { ExpressionEditorLocalePipe } from '../utils/expression-editor-locale.pipe';
import { Table } from './SchemaToStruct';

/**
 * 校验上下文
 * @param localVariableList 变量表
 * @param errors 异常信息
 */
export class CheckContext {
  local: ExpressionEditorLocalePipe;  //国际化
  constructor(local: ExpressionEditorLocalePipe) {
    this.local = local;
  }

  localVariable: any[] = []         //局部变量
  contextVariables: any[] = []      //上下文变量
  sessionVariables: any[] = []      //会话变量
  entityStructs: Table[] = []       //数据模型
  errors: any[] = []                //异常信息
}

/**
 * 函数参数个数校验
 * @description 参数个数校验
 * @param tokens tokens
 * @param errors 异常
 * @param funcs 表达式All内置函数
 */
export function checkFunctionParams(tokens: any[], context: CheckContext, funcs: any[]) {
  var zeroParamFunc = ["Today", "Yesterday", "Tomorrow", "ThisYear", "LastYear", "NextYear", "ThisMonth", "LastMonth", "NextMonth", "ThisWeek",
    "LastWeek", "NextWeek", "DayOfWeek", "FirstDayOfWeek", "LastDayOfWeek", "FirstDayOfLastWeek", "LastDayOfLastWeek", "FirstDayOfNextWeek", "LastDayOfNextWeek", "FirstDayOfMonth",
    "LastDayOfMonth", "FirstDayOfLastMonth", "LastDayOfLastMonth", "FirstDayOfNextMonth", "LastDayOfNextMonth", "FirstDayOfYear", "LastDayOfYear", "FirstDayOfLastYear", "LastDayOfLastYear", "FirstDayOfNextYear",
    "LastDayOfNextYear", "GetDate"];
  var index = [[], [], []]; //二维数组：存储tokens、括号索引、括号索引-不变化版（定位错误行）
  let Num = 1;      //每个峰从1开始
  let max = 0;      //每次的峰值
  let maxs = [];    //多个峰值
  //构造二位数组和max
  for (let i = 0; i < tokens.length; i++) {
    index[0][i] = tokens[i];
    index[1][i] = 0;
    index[2][i] = 0;
    if (tokens[i] == "(") {
      index[1][i] = Num;
      index[2][i] = Num;  //第三行与第二行一致
      if (max < Num) max = Num;
      Num++;
    }
    if (tokens[i] == ")") {
      Num--;
      index[1][i] = Num;
      index[2][i] = Num;  //第三行与第二行一致
      //为0时放置最大值
      if (Num == 1) {
        maxs.push(max);
        max = 0;
      }
    }
  }

  //遍历所有峰值
  maxs.forEach(max => {
    //遍历每个峰
    for (let j = max; j >= 1; j--) {
      //每次indexs存储Num相同
      let start = -1; //此处-1可随意设置，但不要在0~max范围内
      let end = -1;
      for (let i = 0; i < index[0].length; i++) {
        if (index[1][i] == j) {
          if (start == -1) {
            start = i;
          } else {
            end = i;
            break;
          }
        }
      }
      //索引缩减替换为 0（简单识别）
      let eleArray = [];
      for (let m = start; m <= end; m++) {
        eleArray.push(0);
      }
      index[1].splice(start, end - start + 1, ...eleArray);

      let funcTitle = index[0][start - 1];      //当前函数
      //找到对应函数
      let func = funcs.find(func => { return func.name == funcTitle });

      //出错位置定位
      let errStart = 0;
      for (let i = 0; i < index[2].length; i++) {
        if (index[2][i] == j) {
          errStart = i;
          break;
        }
      }
      let line = findErrorLine(tokens, errStart);  //当前函数所在行数

      if (index[0][end - 1] == ",") {
        //参数倒数第二位为","，参数不合法
        context.errors.push(CommonUtils.format(context.local.check("ParamIllegal"), [line, funcTitle]));
      } else if (func != null) {
        //表达式内置函数
        let params = [];      //参数列表
        let paramLength = 0;  //参数长度
        for (let i = start; i <= end; i++) {
          params.push(index[0][i]);
        }

        //参数列表中不含有"[","]"
        if (params.indexOf('[') == -1 && params.indexOf("]") == -1) {
          //参数数量：params至少包含'('、')'
          if (params.length == 2 || (params.length == 3 && params[1].trim() == "")) {   // 长度为2||长度为3且中间为空串
            paramLength = 0;
          } else {
            params.forEach(param => {
              if (param == ",")
                paramLength++;
            })
            paramLength++;  //最终加一（两个","代表三个参数）
          }

          if (paramLength != func.params.length) {
            if (func.key != "Invoke") {
              if (func.key == "Add") {
                if (paramLength > 10) context.errors.push(CommonUtils.format(context.local.check("AddTwoManyParameters"), [line, funcTitle, func.params.length, paramLength]));
              } else if (zeroParamFunc.includes(func.key) && paramLength >= 2) {
                context.errors.push(CommonUtils.format(context.local.check("ParamNumberWithZero"), [line, funcTitle, func.params.length, paramLength]));
              } else if (!zeroParamFunc.includes(func.key)) {
                context.errors.push(CommonUtils.format(context.local.check("ParamNumber"), [line, funcTitle, func.params.length, paramLength]));
              }
            }
          }
        } else if (params.indexOf('[') != -1 && params.indexOf("]") != -1 && params.indexOf('[') < params.indexOf("]")) {
          //参数列表包含"["、"]"，循环移除
          do {
            let left = params.indexOf('[');
            let right = params.indexOf(']');
            //数组内容替换为占位符"$"
            params.splice(left, right - left + 1, "$");
          } while (params.indexOf('[') != -1 && params.indexOf("]") != -1 && params.indexOf('[') < params.indexOf("]"));

          //参数数量：params至少包含'('、')'
          if (params.length == 2 || (params.length == 3 && params[1].trim() == "")) {   // 长度为2||长度为3且中间为空串
            paramLength = 0;
          } else {
            params.forEach(param => {
              if (param == ",")
                paramLength++;
            })
            paramLength++;  //最终加一（两个","代表三个参数）
          }

          if (paramLength != func.params.length) {
            if (func.key != "Invoke") {
              if (func.key == "Add") {
                if (paramLength > 10) context.errors.push(CommonUtils.format(context.local.check("AddTwoManyParameters"), [line, funcTitle, func.params.length, paramLength]));
              } else if (zeroParamFunc.includes(func.key) && paramLength >= 2) {
                context.errors.push(CommonUtils.format(context.local.check("ParamNumberWithZero"), [line, funcTitle, func.params.length, paramLength]));
              } else if (!zeroParamFunc.includes(func.key)) {
                context.errors.push(CommonUtils.format(context.local.check("ParamNumber"), [line, funcTitle, func.params.length, paramLength]));
              }
            }
          }
        } else {
          //数组类型参数不合法
          context.errors.push(CommonUtils.format(context.local.check("ParamArrayIllegal"), [line, funcTitle]));
        }
      }

      //参数个数正确，将此函数缩减替换为 0（简单识别）
      index[0].splice(start, end - start + 1, ...eleArray);

      //将不变索引置为0（方便定位错误位置）
      index[2][start] = 0;
      index[2][end] = 0;

      //当一个范围内存在多个同级时，导致校验异常。例如：0 1 2 2 2 2 1 0   天数差(格式化指定日期("yyyy-MM-dd",root),格式化指定日期("yyyy-MM-dd",root))
      if (j != 1 && findIndex(index[1], 1, 1) < findIndex(index[1], j, 1) && findIndex(index[1], j, 1) < findIndex(index[1], 1, 2)) {
        j++;
      }
    }
  })
}

export function checkEntityStructOfFunctionParam(tokens: any[], context: CheckContext, funcs: any[]) {
  var index = [[], [], []]; //二维数组：存储tokens、括号索引、括号索引-不变化版（定位错误行）
  let Num = 1;      //每个峰从1开始
  let max = 0;      //每次的峰值
  let maxs = [];    //多个峰值
  //构造二位数组和max
  for (let i = 0; i < tokens.length; i++) {
    index[0][i] = tokens[i];
    index[1][i] = 0;
    index[2][i] = 0;
    if (tokens[i] == "(") {
      index[1][i] = Num;
      index[2][i] = Num;  //第三行与第二行一致
      if (max < Num) max = Num;
      Num++;
    }
    if (tokens[i] == ")") {
      Num--;
      index[1][i] = Num;
      index[2][i] = Num;  //第三行与第二行一致
      //为0时放置最大值
      if (Num == 1) {
        maxs.push(max);
        max = 0;
      }
    }
  }

  //遍历所有峰值
  maxs.forEach(max => {
    //遍历每个峰
    for (let j = max; j >= 1; j--) {
      //每次indexs存储Num相同
      let start = -1; //此处-1可随意设置，但不要在0~max范围内
      let end = -1;
      for (let i = 0; i < index[0].length; i++) {
        if (index[1][i] == j) {
          if (start == -1) {
            start = i;
          } else {
            end = i;
            break;
          }
        }
      }
      //索引缩减替换为 0（简单识别）
      let eleArray = [];
      for (let m = start; m <= end; m++) {
        eleArray.push(0);
      }
      index[1].splice(start, end - start + 1, ...eleArray);

      let funcTitle = index[0][start - 1];      //当前函数
      //找到对应函数
      let func = funcs.find(func => { return func.name == funcTitle });

      //出错位置定位
      let errStart = 0;
      for (let i = 0; i < index[2].length; i++) {
        if (index[2][i] == j) {
          errStart = i;
          break;
        }
      }
      let line = findErrorLine(tokens, errStart);  //当前函数所在行数

      // 根据如下的函数进行处理
      if (func != null) {
        if (func.key == "ExistData" || func.key == "CountOfChild") {
          //表达式内置函数
          let params = [];
          let param = "";
          for (let i = start; i <= end; i++) {
            if (params.length == 1) break;

            let ele = index[0][i];
            if (ele != "(" && ele != ")") {
              if (ele == ",") {
                params.push(param);
                param = "";
              } else {
                param = param + ele;
              }
            } else if (ele == ")") {
              if (param.trim() != "") {
                params.push(param);
                param = "";
              }
            }
          }

          let tokens = [];

          let origin = context.errors.length;
          // 校验参数
          checkParamsWrap(params, funcTitle, line, context);

          if (origin == context.errors.length) {
            let subTable = params[0].slice(1, -1);
            tokens = subTable.split(".");

            let tables = context.entityStructs;
            // 寻找主表
            let mainTables = tables.filter(x => x.tableName == tokens[0]);
            if (mainTables != null && mainTables.length > 0) {
              let mainTable = mainTables[0];      //主表名
              if (mainTable != null) {
                // first
                let firstProp = insertElementBetween(tokens, ".");
                check(firstProp, context, mainTable, tables, 0, false, line);
              }
            } else {
              context.errors.push("在第 " + line + " 行, 函数【" + funcTitle + "】的第 1 个参数使用的字段【" + tokens[0] + "】不存在!");
            }
          }
        } else if (func.key == "SortChildData" || func.key == "CountByProp" || func.key == "SumByProp" || func.key == "AvgByProp" || func.key == "MaxByProp" || func.key == "MinByProp") {
          //表达式内置函数
          let params = [];
          let param = "";
          for (let i = start; i <= end; i++) {
            if (params.length == 2) break;

            let ele = index[0][i];
            if (ele != "(" && ele != ")") {
              if (ele == ",") {
                params.push(param);
                param = "";
              } else {
                param = param + ele;
              }
            } else if (ele == ")") {
              if (param.trim() != "") {
                params.push(param);
                param = "";
              }
            }
          }

          let tokens = [];

          let origin = context.errors.length;
          // 校验参数
          checkParamsWrap(params, funcTitle, line, context);

          if (origin == context.errors.length) {
            let subTable = params[0].slice(1, -1);
            tokens = subTable.split(".");

            let tables = context.entityStructs;
            // 寻找主表
            let mainTables = tables.filter(x => x.tableName == tokens[0]);
            if (mainTables != null && mainTables.length > 0) {
              let mainTable = mainTables[0];      //主表名
              if (mainTable != null) {
                // first
                let firstProp = insertElementBetween(tokens, ".");
                firstProp.push("["); firstProp.push("i"); firstProp.push("]"); firstProp.push("."); firstProp.push(...getArrayOfString(params[1]));
                check(firstProp, context, mainTable, tables, 0, false, line);
              }
            } else {
              context.errors.push("在第 " + line + " 行, 函数【" + funcTitle + "】的第 1 个参数使用的字段【" + tokens[0] + "】不存在!");
            }
          }
        } else if (func.key == "IncludedInList") {
          // nothing
        } else if (func.key == "IsExistRecord" || func.key == "IsContainMatch" || func.key == "ListGreaterThan" || func.key == "ListLessThan" || func.key == "ListStartWith" || func.key == "ListEndWith" || func.key == "GetComputeJsonData") {
          //表达式内置函数
          let params = [];
          let param = "";
          for (let i = start; i <= end; i++) {
            if (params.length == 2) break;

            let ele = index[0][i];
            if (ele != "(" && ele != ")") {
              if (ele == ",") {
                params.push(param);
                param = "";
              } else {
                param = param + ele;
              }
            } else if (ele == ")") {
              if (param.trim() != "") {
                params.push(param);
                param = "";
              }
            }
          }

          let tokens = [];

          let origin = context.errors.length;
          // 校验参数
          checkParamsWrap(params, funcTitle, line, context);

          if (origin == context.errors.length) {
            let subTable = params[0].slice(1, -1);
            tokens = subTable.split(".");

            let tables = context.entityStructs;
            // 寻找主表
            let mainTables = tables.filter(x => x.tableName == tokens[0]);
            if (mainTables != null && mainTables.length > 0) {
              let mainTable = mainTables[0];      //主表名

              if (mainTable != null) {
                // first
                let firstProp = insertElementBetween(tokens, ".");
                firstProp.push("["); firstProp.push("i"); firstProp.push("]"); firstProp.push("."); firstProp.push(...getArrayOfString(params[1]));
                check(firstProp, context, mainTable, tables, 0, false, line);
              }
            } else {
              context.errors.push("在第 " + line + " 行, 函数【" + funcTitle + "】的第 1 个参数使用的字段【" + tokens[0] + "】不存在!");
            }
          }
        } else if (func.key == "MultiplyChildNumber") {
          //表达式内置函数
          let params = [];
          let param = "";
          for (let i = start; i <= end; i++) {
            if (params.length == 3) break;

            let ele = index[0][i];
            if (ele != "(" && ele != ")") {
              if (ele == ",") {
                params.push(param);
                param = "";
              } else {
                param = param + ele;
              }
            } else if (ele == ")") {
              if (param.trim() != "") {
                params.push(param);
                param = "";
              }
            }
          }

          let tokens = [];

          let origin = context.errors.length;
          // 校验参数
          checkParamsWrap(params, funcTitle, line, context);

          if (origin == context.errors.length) {
            let subTable = params[0].slice(1, -1);
            tokens = subTable.split(".");

            let tables = context.entityStructs;
            // 寻找主表
            let mainTables = tables.filter(x => x.tableName == tokens[0]);
            if (mainTables != null && mainTables.length > 0) {
              let mainTable = mainTables[0];      //主表名
              if (mainTable != null) {
                // first
                let firstProp = insertElementBetween(tokens, ".");
                firstProp.push("["); firstProp.push("i"); firstProp.push("]"); firstProp.push("."); firstProp.push(...getArrayOfString(params[1]));
                check(firstProp, context, mainTable, tables, 0, false, line);

                // second
                let secondProp = insertElementBetween(tokens, ".");
                secondProp.push("["); secondProp.push("i"); secondProp.push("]"); secondProp.push("."); secondProp.push(...getArrayOfString(params[2]));
                check(secondProp, context, mainTable, tables, 0, false, line);
              }

            } else {
              context.errors.push("在第 " + line + " 行, 函数【" + funcTitle + "】的第 1 个参数使用的字段【" + tokens[0] + "】不存在!");
            }
          }
        } else if (func.key == "MinValueOfPeriod" || func.key == "MaxValueOfPeriod" || func.key == "AvgValueOfPeriod") {
          //表达式内置函数
          let params = [];
          let param = "";
          for (let i = start; i <= end; i++) {
            if (params.length == 3) break;

            let ele = index[0][i];
            if (ele != "(" && ele != ")") {
              if (ele == ",") {
                params.push(param);
                param = "";
              } else {
                param = param + ele;
              }
            } else if (ele == ")") {
              if (param.trim() != "") {
                params.push(param);
                param = "";
              }
            }
          }

          let tokens = [];

          let origin = context.errors.length;
          // 校验参数
          checkParamsWrap(params, funcTitle, line, context);

          if (origin == context.errors.length) {
            let subTable = params[0].slice(1, -1);
            tokens = subTable.split(".");

            let tables = context.entityStructs;
            // 寻找主表
            let mainTables = tables.filter(x => x.tableName == tokens[0]);
            if (mainTables != null && mainTables.length > 0) {
              let mainTable = mainTables[0];      //主表名
              if (mainTable != null) {
                // first
                let firstProp = insertElementBetween(tokens, ".");
                firstProp.push("["); firstProp.push("i"); firstProp.push("]"); firstProp.push("."); firstProp.push(...getArrayOfString(params[1]));
                check(firstProp, context, mainTable, tables, 0, false, line);

                // second
                let secondProp = insertElementBetween(tokens, ".");
                secondProp.push("["); secondProp.push("i"); secondProp.push("]"); secondProp.push("."); secondProp.push(...getArrayOfString(params[2]));
                check(secondProp, context, mainTable, tables, 0, false, line);

                // second
                let thirdProp = insertElementBetween(tokens, ".");
                thirdProp.push("["); thirdProp.push("i"); thirdProp.push("]"); thirdProp.push("."); thirdProp.push(...getArrayOfString(params[3]));
                check(thirdProp, context, mainTable, tables, 0, false, line);
              }

            } else {
              context.errors.push("在第 " + line + " 行, 函数【" + funcTitle + "】的第 1 个参数使用的字段【" + tokens[0] + "】不存在!");
            }
          }
        } else if (func.key == "GetInjectedEntity") {
        } else if (func.key == "GetChainedPropertyValue") {
        }
      }

      //参数个数正确，将此函数缩减替换为 0（简单识别）
      index[0].splice(start, end - start + 1, ...eleArray);

      //将不变索引置为0（方便定位错误位置）
      index[2][start] = 0;
      index[2][end] = 0;

      //当一个范围内存在多个同级时，导致校验异常。例如：0 1 2 2 2 2 1 0   天数差(格式化指定日期("yyyy-MM-dd",root),格式化指定日期("yyyy-MM-dd",root))
      if (j != 1 && findIndex(index[1], 1, 1) < findIndex(index[1], j, 1) && findIndex(index[1], j, 1) < findIndex(index[1], 1, 2)) {
        j++;
      }
    }
  })
}

function insertElementBetween(arr, elementToInsert) {
  const result = [];
  for (let i = 0; i < arr.length; i++) {
    result.push(arr[i]);
    if (i < arr.length - 1) {
      result.push(elementToInsert);
    }
  }
  return result;
}

function checkParamsWrap(params: any, funcName: string, line: number, context: CheckContext) {
  for (let i = 0; i < params.length; i++) {
    let param = params[i];
    if ((param.startsWith("'") && param.endsWith("'")) || (param.startsWith("\"") && param.endsWith("\""))) {
    } else {
      context.errors.push("在第 " + line + " 行, 函数【" + funcName + "】的第 " + (i + 1) + " 个参数没有使用\"\"包起来, 请参考函数说明检查调整!");
    }
  }
}

/**
 * 在数组{arr}中查找第{times}次出现的目标元素{target}，并返回其索引
 * @param arr 数组
 * @param target 目标元素
 * @param times 次数
 * @returns 索引
 */
function findIndex(arr: any[], target: number, times: number) {
  let count = 0;
  for (let i in arr) {
    if (arr[i] == target) {
      count++;
      if (count == times) {
        return Number(i);
      }
    }
  }

  return Number(-1);
}

/**
 * 检查数据模型
 * @param tokens 
 * @param context 
 */
export function checkEntityStruct(tokens: any[], context: CheckContext) {
  let tables = context.entityStructs;
  let mainTable = tables[tables.length - 1];      //主表名
  if (mainTable != null) {
    //有数据模型
    let mainTableIndexs = [];                       //tokens中出现的主表名
    tokens.forEach((token, index) => {
      if (token == mainTable.tableName)
        mainTableIndexs.push(index);
    });

    mainTableIndexs.forEach(tableIndex => {
      check(tokens, context, mainTable, tables, tableIndex, false);
    })
  }
}

function check(tokens: any[], context: CheckContext, table: Table, tables: Table[], index: number, isSet: boolean, lineParam: number = -1) {
  let line = 1;
  if (lineParam != -1) line = lineParam;
  else line = findErrorLine(tokens, index);  //当前变量所在行
  let parent = tokens[index];
  if (isSet) {
    if (tokens[index + 1] == "[") {
      //子表一般情况：People.friends[i].name
      for (let i = index + 1; i < tokens.length; i++) {
        if (tokens[i] == "]") {
          index = i;
          break;
        }
      }

      if (tokens[index + 1] == ".") {
        let proList = table.properties.filter(property => { return property.code == tokens[index + 2] });
        if (proList.length == 1) {
          //index+2在表中
          let pro = proList[0];
          if (pro.type == "Set") {
            let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
            check(tokens, context, setTable, tables, index + 2, true, lineParam);
          } else if (pro.type == "Type") {
            let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
            check(tokens, context, setTable, tables, index + 2, false, lineParam);
          } else {
            //普通属性
            if (tokens[index + 3] == ".") {
              context.errors.push(CommonUtils.format(context.local.check("SimpleNoProperty"), [line, pro.code]));
            }
          }
        } else {
          //index+2不在表中
          context.errors.push(CommonUtils.format(context.local.check("ChildNoProperty"), [line, table.tableName, tokens[index + 2]]));
        }
      }
    } else if (tokens[index + 1] == ".") {
      // 兼容表单场景，表单场景中，子表后面没有中括号（People.friends.name）
      let proList = table.properties.filter(property => { return property.code == tokens[index + 2] });
      if (proList.length == 1) {
        //index+2在表中
        let pro = proList[0];
        if (pro.type == "Set") {
          let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
          check(tokens, context, setTable, tables, index + 2, true, lineParam);
        } else if (pro.type == "Type") {
          let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
          check(tokens, context, setTable, tables, index + 2, false, lineParam);
        } else {
          //普通属性
          if (tokens[index + 3] == ".") {
            context.errors.push(CommonUtils.format(context.local.check("SimpleNoProperty"), [line, pro.code]));
          }
        }
      } else {
        //index+2不在表中
        context.errors.push(CommonUtils.format(context.local.check("ChildNoProperty"), [line, table.tableName, tokens[index + 2]]));
      }
    }
  } else {
    //非子表
    if (tokens[index + 1] == ".") {
      let proList = table.properties.filter(property => { return property.code == tokens[index + 2] });
      if (proList.length == 1) {
        //index+2在表中
        let pro = proList[0];
        if (pro.type == "Set") {
          let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
          check(tokens, context, setTable, tables, index + 2, true, lineParam);
        } else if (pro.type == "Type") {
          let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
          check(tokens, context, setTable, tables, index + 2, false, lineParam);
        } else {
          //普通属性
          if (tokens[index + 3] == ".") {
            context.errors.push(CommonUtils.format(context.local.check("SimpleNoProperty"), [line, pro.code]));
          }
        }
      } else {
        //index+2不在表中
        context.errors.push(CommonUtils.format(context.local.check("PropertyNoProperty"), [line, table.tableName, tokens[index + 2]]));
      }
    }
  }
}

function getArrayOfString(str) {
  str = str.slice(1, -1);
  let arr = str.split(".");
  arr = arr.flatMap((item, index) =>
    index < arr.length - 1 ? [item, '.'] : [item]
  );

  return arr;
}

/**
 * 检查变量
 * @param tokens tokens
 * @param context 校验上下文
 * @param functions 函数
 * @param names 变量名称list
 */
export function checkVariable(tokens: any[], context: CheckContext, functions: any[], names: any[]) {
  //查找对应两个函数
  let funs = [];
  for (let i = 0; i < functions.length; i++) {
    if (functions.length != 2) {
      //找到两个，结束
      if (functions[i].key == "GetContextParameter") {
        funs[0] = functions[i].name;
      }
      if (functions[i].key == "GetSessionValue") {
        funs[1] = functions[i].name;
      }
    } else {
      break;
    }
  }

  //遍历tokens，寻找funs
  for (let i = 0; i < tokens.length; i++) {
    //校验是否填写
    if (funs.includes(tokens[i]) && tokens[i + 1] == "(" && tokens[i + 3] == ")" && ((tokens[i + 2] as string).startsWith("\"") || (tokens[i + 2] as string).startsWith("'"))) {
      let tempValue = tokens[i + 2];
      if (tempValue != null) {
        //取真实值
        tempValue = tempValue.slice(1, tempValue.length - 1);
        //不存在则提示
        if (!names.includes(tempValue)) {
          if (tempValue.length == 0) {
            if (funs.indexOf(tokens[i]) == 0)
              context.errors.push(CommonUtils.format(context.local.check("ContextNotSet"), [findErrorLine(tokens, i)]));
            else if (funs.indexOf(tokens[i]) == 1)
              context.errors.push(CommonUtils.format(context.local.check("SessionNotSet"), [findErrorLine(tokens, i)]));
          } else {
            if (funs.indexOf(tokens[i]) == 0)
              context.errors.push(CommonUtils.format(context.local.check("ContextNotExist"), [findErrorLine(tokens, i), tempValue]));
            else if (funs.indexOf(tokens[i]) == 1)
              context.errors.push(CommonUtils.format(context.local.check("SessionNotExist"), [findErrorLine(tokens, i), tempValue]));
          }
        }
      }
    }
  }
}

/**
 * 找出出错所在行
 * @param tokens 
 * @param end 
 * @returns 
 */
function findErrorLine(tokens: any[], end: number): number {
  //找出\r\n
  let line = 1;
  for (let i = 0; i < end; i++) {
    if (tokens[i] != null && tokens[i].includes("\n")) {
      let ele = tokens[i];
      while (ele.includes("\n")) {
        line++;

        ele = ele.replace("\n", "#")
      }
    }
    // line++;
  }
  return line;
}

//###################2024-11-12 提取数据模型字段##############################################

/**
 * 检查数据模型
 * @param tokens 
 * @param context 
 */
export function getDataModelProperty(tokens: any[], context: CheckContext) {
  let proerties = [];
  let tables = context.entityStructs;
  let mainTable = tables[tables.length - 1];      //主表名
  if (mainTable != null) {
    //有数据模型
    let mainTableIndexs = [];                       //tokens中出现的主表名
    tokens.forEach((token, index) => {
      if (token == mainTable.tableName)
        mainTableIndexs.push(index);
    });

    mainTableIndexs.forEach(tableIndex => {
      checkGetProp(tokens, context, mainTable, tables, tableIndex, false, proerties, mainTable.tableName);
    })
  }

  return proerties;
}

function checkGetProp(tokens: any[], context: CheckContext, table: Table, tables: Table[], index: number, isSet: boolean, props: any, prefix: string) {
  let line = findErrorLine(tokens, index);  //当前变量所在行
  let parent = tokens[index];
  if (isSet) {
    if (tokens[index + 1] == "[") {
      //子表一般情况：People.friends[i].name
      for (let i = index + 1; i < tokens.length; i++) {
        if (tokens[i] == "]") {
          index = i;
          break;
        }
      }
      if (tokens[index + 1] == ".") {
        let proList = table.properties.filter(property => { return property.code == tokens[index + 2] });
        if (proList.length == 1) {
          //index+2在表中
          let pro = proList[0];
          if (pro.type == "Set") {
            let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
            checkGetProp(tokens, context, setTable, tables, index + 2, true, props, prefix + "." + setTable.tableName);
          } else if (pro.type == "Type") {
            let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
            checkGetProp(tokens, context, setTable, tables, index + 2, false, props, prefix + "." + setTable.tableName);
          } else {
            //普通属性
            if (tokens[index + 3] == ".") {
              context.errors.push(CommonUtils.format(context.local.check("SimpleNoProperty"), [line, pro.code]));
            } else {
              props.push(prefix + "." + pro.code)
            }
          }
        } else {
          //index+2不在表中
          context.errors.push(CommonUtils.format(context.local.check("ChildNoProperty"), [line, table.tableName, tokens[index + 2]]));
        }
      }
    } else if (tokens[index + 1] == "." && tokens[index + 2] != "length") {
      //子表属性特殊情况：People.friends.length
      context.errors.push(CommonUtils.format(context.local.check("ChildNoProperty"), [line, table.tableName, tokens[index + 2]]));
    }
  } else {
    //非子表
    if (tokens[index + 1] == ".") {
      let proList = table.properties.filter(property => { return property.code == tokens[index + 2] });
      if (proList.length == 1) {
        //index+2在表中
        let pro = proList[0];
        if (pro.type == "Set") {
          let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
          checkGetProp(tokens, context, setTable, tables, index + 2, true, props, prefix + "." + setTable.tableName);
        } else if (pro.type == "Type") {
          let setTable = tables.filter(t => { return t.tableName == pro.code && (t.parent == parent || t.parent + "s" == parent) })[0];
          checkGetProp(tokens, context, setTable, tables, index + 2, false, props, prefix + "." + setTable.tableName);
        } else {
          //普通属性
          if (tokens[index + 3] == ".") {
            context.errors.push(CommonUtils.format(context.local.check("SimpleNoProperty"), [line, pro.code]));
          } else {
            props.push(prefix + "." + pro.code)
          }
        }
      } else {
        //index+2不在表中
        context.errors.push(CommonUtils.format(context.local.check("PropertyNoProperty"), [line, table.tableName, tokens[index + 2]]));
      }
    }
  }
}

export function getDataModelPropertyFromFunctionParam(tokens: any, context: CheckContext) {
  let props = [];
  var oneParamFunc = ["ExistData", "CountOfChild", "GetInjectedEntity", "GetChainedPropertyValue"];
  var twoParamFunc = ["SortChildData", "CountByProp", "SumByProp", "AvgByProp", "MaxByProp", "MinByProp", "IsExistRecord", "IsContainMatch", "ListGreaterThan", "ListLessThan", "ListStartWith", "ListEndWith", "GetComputeJsonData"];
  var threeParamFunc = ["MultiplyChildNumber", "MinValueOfPeriod", "MaxValueOfPeriod", "AvgValueOfPeriod"];

  var index = [[], [], []]; //二维数组：存储tokens、括号索引、括号索引-不变化版（定位错误行）
  let Num = 1;      //每个峰从1开始
  let max = 0;      //每次的峰值
  let maxs = [];    //多个峰值
  //构造二位数组和max
  for (let i = 0; i < tokens.length; i++) {
    index[0][i] = tokens[i];
    index[1][i] = 0;
    index[2][i] = 0;
    if (tokens[i] == "(") {
      index[1][i] = Num;
      index[2][i] = Num;  //第三行与第二行一致
      if (max < Num) max = Num;
      Num++;
    }
    if (tokens[i] == ")") {
      Num--;
      index[1][i] = Num;
      index[2][i] = Num;  //第三行与第二行一致
      //为0时放置最大值
      if (Num == 1) {
        maxs.push(max);
        max = 0;
      }
    }
  }

  //遍历所有峰值
  maxs.forEach(max => {
    //遍历每个峰
    for (let j = max; j >= 1; j--) {
      //每次indexs存储Num相同
      let start = -1; //此处-1可随意设置，但不要在0~max范围内
      let end = -1;
      for (let i = 0; i < index[0].length; i++) {
        if (index[1][i] == j) {
          if (start == -1) {
            start = i;
          } else {
            end = i;
            break;
          }
        }
      }
      //索引缩减替换为 0（简单识别）
      index[1].splice(start, end - start + 1);

      let funcTitle = index[0][start - 1];      //当前函数
      // console.log(funcTitle);
      //找到对应函数
      // let func = funcs.find(func => { return func.name == funcTitle });
      let func = "";

      //出错位置定位
      let errStart = 0;
      for (let i = 0; i < index[2].length; i++) {
        if (index[2][i] == j) {
          errStart = i;
          break;
        }
      }
      let line = findErrorLine(tokens, errStart);  //当前函数所在行数

      if (index[0][end - 1] == ",") {
        //参数倒数第二位为","，参数不合法
        context.errors.push(CommonUtils.format(context.local.check("ParamIllegal"), [line, funcTitle]));
      } else if (func != null) {
        //表达式内置函数
        let params = [];      //参数列表
        for (let i = start; i <= end; i++) {
          params.push(index[0][i]);
        }


        let parameterList = [];
        for (let i = 0; i < params.length; i++) {
          let p = params[i];
          if (p != "(" && p != ")" && p != "," && p.trim() != "") {
            parameterList.push(p);
          }
        }

        // extract property by fun
        if (oneParamFunc.includes(funcTitle)) {
          let f = (parameterList[0] as string).slice(1, parameterList[0].length - 1);
          props.push(f);
        } else if (twoParamFunc.includes(funcTitle)) {
          let f = (parameterList[0] as string).slice(1, parameterList[0].length - 1);
          let s = (parameterList[1] as string).slice(1, parameterList[1].length - 1);
          props.push(f + "[i]." + s);
        } else if (threeParamFunc.includes(funcTitle)) {
          let f = (parameterList[0] as string).slice(1, parameterList[0].length - 1);
          let s = (parameterList[1] as string).slice(1, parameterList[1].length - 1);
          let t = (parameterList[2] as string).slice(1, parameterList[2].length - 1);
          props.push(f + "[i]." + s);
          props.push(f + "[i]." + t);
        }

        // console.log(props);
      }

      //参数个数正确，将此函数缩减替换为 0（简单识别）
      index[0].splice(start, end - start + 1);

      //将不变索引置为0（方便定位错误位置）
      index[2][start] = 0;
      index[2][end] = 0;

      //当一个范围内存在多个同级时，导致校验异常。例如：0 1 2 2 2 2 1 0   天数差(格式化指定日期("yyyy-MM-dd",root),格式化指定日期("yyyy-MM-dd",root))
      if (j != 1 && findIndex(index[1], 1, 1) < findIndex(index[1], j, 1) && findIndex(index[1], j, 1) < findIndex(index[1], 1, 2)) {
        j++;
      }
    }
  })

  return props;
}

export function findContextVariable(tokens: any[], varMap: any): Array<{ code: any, name: any }> {
  return findVariable(tokens, varMap, "GetContextParameter");
}

export function findSessionVariable(tokens: any[], varMap: any): Array<{ code: any, name: any }> {
  return findVariable(tokens, varMap, "GetSessionValue");
}

function findVariable(tokens: any[], varMap: any, type: string): Array<{ code: any, name: any }> {
  let variables: Array<{ code: any, name: any }> = [];
  //find variable
  for (let i = 0; i < tokens.length; i++) {
    if (type == tokens[i] && tokens[i + 1] == "(" && tokens[i + 3] == ")" && ((tokens[i + 2] as string).startsWith("\"") || (tokens[i + 2] as string).startsWith("'"))) {
      let variableCode = tokens[i + 2];
      if (variableCode != null) {
        //real variable code
        variableCode = variableCode.slice(1, variableCode.length - 1);
        if (varMap.has(variableCode)) {
          variables.push({ code: variableCode, name: varMap.get(variableCode) });
        } else {
          if (variableCode.length == 0) {
            //TODO log non-existent variable
          }
        }
      }
    }
  }

  return variables;
}